import React from "react";

const TopSellingProducts = () => {
  return (
    <div>
      <h2 className="text-xl font-bold mb-4">📈 Top Selling Products</h2>
      <p>Highlight products with the most sales volume or value.</p>
    </div>
  );
};

export default TopSellingProducts;
